var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    { ref: "app", staticClass: "app", attrs: { id: "qplus" } },
    [
      _vm.language
        ? _c("Main", {
            class: {
              iOS: _vm.is_iOS,
              Safari: _vm.is_Safari
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }